import { render, staticRenderFns } from "./UnfoldingTable.vue?vue&type=template&id=8408b02a&scoped=true&"
import script from "./UnfoldingTable.vue?vue&type=script&lang=js&"
export * from "./UnfoldingTable.vue?vue&type=script&lang=js&"
import style0 from "./UnfoldingTable.vue?vue&type=style&index=0&id=8408b02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8408b02a",
  null
  
)

export default component.exports